import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import logo from './logo.svg';
import './App.css';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import About from './components/About';
import Team from './components/Team';
import Courses from './components/Courses';
import Contact from './components/Contact';
import Home from './components/Home';

function App() {
  return (
    <Router>
      <Navbar logo="Panada Fitness"/>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/team" element={<Team />} />
        <Route path="/courses" element={<Courses />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>
      <Footer logo="Panada Fitness"/>
    </Router>
  );
}

export default App;
